import React, { FormEvent } from 'react'
import Autosuggest from 'react-autosuggest'

import { TextInput } from '@acorns/web-components'

import { EmailDomains } from 'components/EmailInput'
import { Suggestion, SuggestionWrapper, SuggestionsContainer } from 'components/EmailInput'

type StateProps = {
  suggestions: string[]
}

type Props = {
  errors: object
  handleChange: (event: FormEvent<HTMLInputElement>) => void
  label?: string
  maxLength?: number
  name: string
  placeholder?: string
  setFieldValue: (field: string, value: any, shouldRevalidate: boolean) => void
  values: object
}

const renderInputComponent = inputProps => (
  <TextInput
    autocomplete="off"
    error={inputProps.error}
    errorText={inputProps.errorText}
    id={inputProps.name}
    name={inputProps.name}
    type="text"
    value={inputProps.value}
    {...inputProps}
    ref={null} // Function components cannot be given refs.
  />
)

const renderSuggestionsContainer = ({ children, containerProps }) => (
  <SuggestionWrapper>
    <SuggestionsContainer shouldRenderContainer={!!children} {...containerProps}>
      {children}
    </SuggestionsContainer>
  </SuggestionWrapper>
)

export const renderSuggestion = (suggestion, { isHighlighted }) => (
  <Suggestion highlighted={isHighlighted}>@{suggestion}</Suggestion>
)

class EmailInput extends React.Component<Props, StateProps> {
  constructor(props) {
    super(props)

    this.state = {
      suggestions: [],
    }

    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this)
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this)
  }

  public getSuggestions = value => {
    const domain = value.split('@')[1] || ''
    const inputValue = domain.trim().toLowerCase()
    const inputLength = inputValue.length

    let suggestions = EmailDomains.filter(dom => dom.slice(0, inputLength) === inputValue)

    if (inputLength === 0) {
      suggestions = []
    }

    // Hide completed suggestion
    if (suggestions.length === 1 && suggestions[0] === inputValue) {
      suggestions = []
    }

    return suggestions
  }

  public getSuggestionValue = suggestion => {
    const address = this.props.values[this.props.name].split('@')[0]
    return `${address}@${suggestion}`
  }

  public onSuggestionSelected = (_, { suggestionValue }) => {
    this.props.setFieldValue(this.props.name, suggestionValue, true)
  }

  public onChange = event => {
    this.props.handleChange(event)
  }

  public onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    })
  }

  public onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    })
  }

  public render() {
    const { suggestions } = this.state

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      label: this.props.label,
      name: this.props.name,
      value: this.props.values[this.props.name],
      onChange: this.onChange,
      error: this.props.errors[this.props.name],
      errorText: this.props.errors[this.props.name],
      values: this.props.values,
      placeholder: this.props.placeholder,
    }

    // istanbul ignore next
    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestionsContainer={renderSuggestionsContainer}
        renderSuggestion={renderSuggestion}
        renderInputComponent={renderInputComponent}
        inputProps={inputProps}
        focusInputOnSuggestionClick={false}
      />
    )
  }
}

export default EmailInput
